package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
interface PayEnvironment: Environment {
    val cartsPath: String
    val ordersPath: String
    val payAuthPath: String
    val payHost: String
    val productsPath: String
    val subscriptionsPath: String
    val plansPath: String
    val vizioApiSubscriptionKey: String
    val walletPath: String
    val messageTokenAESKeyMasked: String?
    val marketingApiPath: String
    val rewardsPath: String
}

@JsExport
abstract class BasePayEnvironment(
    override val cartsPath: String = "carts-api",
    override val ordersPath: String = "orders-api",
    override val payAuthPath: String = "myvizio-api",
    override val productsPath: String = "products-api",
    override val subscriptionsPath: String = "subscriptions-api",
    override val plansPath: String = "plans-api",
    override val walletPath: String = "wallet-api",
    override val marketingApiPath: String = "marketing-api",
    override val rewardsPath: String = "rewards-api"
): PayEnvironment

@JsExport
data class DevPayEnvironment(
    override val vizioApiSubscriptionKey: String,
    override val payHost: String = "apim-vizio-ecommerce-dev.vizio.com",
    override val messageTokenAESKeyMasked: String?
): BasePayEnvironment()

@JsExport
data class QaPayEnvironment(
    override val vizioApiSubscriptionKey: String,
    override val payHost: String = "apim-vizio-ecommerce-qa.vizio.com",
    override val messageTokenAESKeyMasked: String?
): BasePayEnvironment()

@JsExport
data class PreProdPayEnvironment(
    override val vizioApiSubscriptionKey: String,
    override val payHost: String = "apim-vizio-ecommerce-preprod.vizio.com",
    override val messageTokenAESKeyMasked: String?
): BasePayEnvironment()

@JsExport
data class ProdPayEnvironment(
    override val vizioApiSubscriptionKey: String,
    override val payHost: String = "apim-vizio-ecommerce-prod.vizio.com",
    override val messageTokenAESKeyMasked: String?
): BasePayEnvironment()

fun choosePayEnvironment(eCommerceEnvConfig: ECommerceEnvironmentConfig): PayEnvironment {
    return when (eCommerceEnvConfig.environmentGroup) {
        EnvironmentGroup.PROD -> ProdPayEnvironment(vizioApiSubscriptionKey = eCommerceEnvConfig.apiKey, messageTokenAESKeyMasked = eCommerceEnvConfig.messageTokenAESKeyMasked)
        EnvironmentGroup.PREPROD -> PreProdPayEnvironment(vizioApiSubscriptionKey = eCommerceEnvConfig.apiKey, messageTokenAESKeyMasked = eCommerceEnvConfig.messageTokenAESKeyMasked)
        EnvironmentGroup.STAGE -> QaPayEnvironment(vizioApiSubscriptionKey = eCommerceEnvConfig.apiKey, messageTokenAESKeyMasked = eCommerceEnvConfig.messageTokenAESKeyMasked)
        EnvironmentGroup.DEV -> DevPayEnvironment(vizioApiSubscriptionKey = eCommerceEnvConfig.apiKey, messageTokenAESKeyMasked = eCommerceEnvConfig.messageTokenAESKeyMasked)
        EnvironmentGroup.TEST -> TODO("Test Environment for Pay not defined!")
    }
}
